import controller from './family-plan.controller';
import familPlanController from './family-plan.controller';

export default {
  bindings: {
    type: '<'
  },
  controller ,
  template: require('./family-plan.html')
};



// WEBPACK FOOTER //
// src/app/family-plan/family-plan.component.ts